import I18n from "i18n-js";
import React from "react";

class DevicesSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      devices: this.props.devices,
    };
    this.ref = React.createRef();
    this.getDeviceIds = this.getDeviceIds.bind(this);
  }

  componentDidMount() {
    this.initSelect2();
  }

  initSelect2() {
    // console.log(
    //   "DevicesSelect",
    //   this.props.devices,
    //   this.props.devices.map((device) => {
    //     return device.external_id;
    //   })
    // );
    var self = this;
    if (this.ref && this.ref.current) {
      $(this.ref.current)
        .select2({
          multiple: true,
          language: {
            noResults: () => {
              return "";
            },
          },
          data: this.props.devices.map((device) => {
            return { id: device.external_id, text: device.name };
          }),
          ajax: {
            url: "/admin/devices_remote",
            dataType: "json",
            delay: 250,
            data: function (params) {
              return {
                q: params.term,
                page: params.page,
                results_per_page: 40,
                device_ids: self.getDeviceIds(),
              };
            },
            processResults: function (data, params) {
              params.page = params.page || 1;
              //console.log("processResults", data.items);
              return {
                results: data.items,
                pagination: {
                  more: params.page * 40 < data.total_count,
                },
              };
            },
            cache: false,
          },
          allowClear: false,
          escapeMarkup: function (markup) {
            return markup;
          },
          placeholder: I18n.t("select_ellipsis"),
          templateResult: function (device) {
            //console.log("templateResult", device);
            if (device.loading) {
              return device.text;
            }
            return self.processDevice(device);
          },
          templateSelection: function (device) {
            // console.log("templateSelection", device);
            return self.optionTemplate(device);
          },
        })
        .on("change", function (e) {
          var select2_data = $(self.ref.current).select2("data");
          //console.log("onChange", select2_data);
          self.props.onChange(select2_data);
        });
    }
  }

  render() {
    //console.log("DevicesSelect", this.props.devices, this.state.devices);
    var self = this;
    const devices = this.state.devices.filter((value, index, self) => {
      return (
        self.findIndex((v) => v.external_id === value.external_id) === index
      );
    });
    //console.log("devices", devices);
    var options =
      devices && devices.length > 0
        ? devices.map(function (device) {
            return (
              <option key={device.external_id} value={device.external_id}>
                {self.processDevice(device)}
              </option>
            );
          })
        : [];

    var values =
      devices && devices.length > 0
        ? devices.map(function (device) {
            return device.external_id;
          })
        : [];
    return (
      <div>
        <select
          defaultValue={values}
          multiple={true}
          className="form-control"
          ref={this.ref}
          style={{ width: "100%", minHeight: 33 }}
        >
          {options}
        </select>
      </div>
    );
  }

  optionTemplate(device) {
    //console.log("optionTemplate", device);
    return (
      '<span><span class="option-data">' +
      this.processDevice(device) +
      "</span></span>"
    );
  }

  processDevice(device) {
    //console.log("processDevice", device);
    return device.name || device.text;
  }

  getDeviceIds() {
    //console.log("getDeviceIds", this.props.devices);
    const device_ids = this.props.devices.map((device) => {
      return device.external_id || device.id;
    });
    //console.log("device_ids", device_ids);
    return device_ids;
  }
}

export default DevicesSelect;
